export const environment = {
  apiUrl: 'https://service.talentsearch.pro',
};
